// @flow
import * as React from 'react'
import Dropdown from '../../../core/Dropdown'
import BaseField from '../../../core/BaseField'
import SelectInput from '../SelectInput'

// Types
import type { RenderValueFunc, RenderOptionFunc } from '../../../core/Dropdown'
import type { Props as BaseFieldProps } from '../../../core/BaseField'
import type { InputComponentProps } from '../../../core/Input'

export type Props = BaseFieldProps &
  InputComponentProps & {
    combobox?: boolean,
    options: Array<any>,
    optionSize?: *,
    renderOption: RenderOptionFunc,
    renderValue?: RenderValueFunc,
    showed?: boolean,
    maxHeight?: string,
    maxWidth?: string,
    popperModifiers?: Object,
    onFocusOption?: (any, number) => any,
    onHidePopper?: () => any,
    onCloseMobileSelector?: () => any,
    filterTargetProps?: (Object) => Object,
  }

/**
 * Simple pretty select input field that can be used to showed
 * simple selectors.
 */
class DesktopSelectField extends React.Component<Props> {
  dropdownInstance = null

  latestTargetRef = null

  static defaultProps = {
    renderOption: (x: any) => x,
    options: [],
    maxHeight: '300px',
    maxWidth: '100%',
    popperModifiers: {
      flip: { behavior: ['bottom'] },
      preventOverflow: { enabled: false },
      hide: { enabled: false },
    },
    input: {},
    meta: {},
  }

  hideOptions() {
    if (this.dropdownInstance) {
      this.dropdownInstance.hidePopper()
    }
  }

  setDropdownRef = (node: ?Dropdown) => {
    this.dropdownInstance = node
  }

  setContainerRef = (c: *) => {
    const { containerRef } = this.props
    this.latestTargetRef && this.latestTargetRef(c)
    containerRef && containerRef(c)
  }

  renderTarget = (innerRef: any, targetProps: any) => {
    const { options } = this.props
    const finalInputProps = !this.props.disabled ? targetProps : {}
    const hasOptions = options && !!options.length

    // Dirty hack, but there is no other way to make containerRef
    // to be a stable reference
    this.latestTargetRef = innerRef

    return (
      <BaseField
        selectable={hasOptions}
        {...this.props}
        type={this.props.combobox ? 'text' : 'static'}
        containerRef={this.setContainerRef}
        innerRef={this.props.focusableRef}
        renderInput={(props) => <SelectInput {...props} />}
        input={{
          ...this.props.input,
          ...finalInputProps,
        }}
      />
    )
  }

  handleOptionSelect = (value: any, index: number) => {
    const {
      input: { onChange },
    } = this.props
    onChange && onChange(value, index)
  }

  render() {
    const {
      meta,
      showed,
      maxHeight,
      maxWidth,
      options,
      optionSize,
      onFocusOption,
      onHidePopper,
      renderOption,
      renderValue,
      filterTargetProps,
      popperModifiers,
    } = this.props

    return (
      <Dropdown
        ref={this.setDropdownRef}
        showed={showed}
        filterTargetProps={filterTargetProps}
        loading={meta.loading}
        renderOption={renderOption}
        renderValue={renderValue}
        options={options}
        optionSize={optionSize}
        target={this.renderTarget}
        onFocusOption={onFocusOption}
        onHidePopper={onHidePopper}
        onSelect={this.handleOptionSelect}
        maxHeight={maxHeight}
        maxWidth={maxWidth}
        popperModifiers={popperModifiers}
      />
    )
  }
}

export default DesktopSelectField
